import { DefineComponent, FunctionalComponent, SetupContext } from "vue";
import { MenuItemDefinition, showMenu } from "#skyward_modalLayer";
import { Key } from "../../types/skyward/svg";
import Button from "./button";

type MoreMenuProps =
{
    items: MenuItemDefinition[];
    svgClasses?: string[];
    svgColor?: string;
    onMouseover?: (e: MouseEvent) => void;
    onMouseout?: (e: MouseEvent) => void;
};

const MoreMenu: FunctionalComponent<MoreMenuProps> = function vMoreMenu(props: MoreMenuProps, _context: SetupContext)
{
    return (
        <div class="moreMenuArea">
            <Button svgName={"ArrowTriangleDown" as Key} svgColor={props.svgColor} svgClasses={props.svgClasses} aria-haspopup="menu" aria-label="More options" clickFunc={onClick} onMouseover={props.onMouseover} onMouseout={props.onMouseout} />
        </div>
    );

    function onClick(e: MouseEvent)
    {
        const anchor = e.target as HTMLElement;
        showMenu(props.items, anchor, { beforeClose: function () { anchor.focus(); } });
    }
};

MoreMenu.props = ["items", "svgClasses", "svgColor", "onMouseover", "onMouseout"];
export default MoreMenu as unknown as DefineComponent<MoreMenuProps, JSX.Element>;
